import { DownloadSimple, ArrowSquareOut, FileText } from "@phosphor-icons/react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { API_BASE } from "../lib/api";

export function attachmentFileUrl(path) {
  const token = localStorage.getItem("helios_token");
  return `${API_BASE}${path}${token ? `?token=${encodeURIComponent(token)}` : ""}`;
}

const kindOf = (name = "", type = "") => {
  if (type === "application/pdf" || /\.pdf$/i.test(name)) return "pdf";
  if (type.startsWith("image/") || /\.(png|jpe?g|gif|webp|bmp)$/i.test(name)) return "image";
  if (type.startsWith("text/") || /\.(txt|log|csv|md)$/i.test(name)) return "pdf";
  return "other";
};

// file = { name, type, path } where path is the API path, e.g. /kb/attachments/<id>
export function AttachmentPreview({ file, onClose }) {
  const url = file ? attachmentFileUrl(file.path) : "";
  const kind = file ? kindOf(file.name, file.type || "") : "other";
  return (
    <Dialog open={!!file} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-5xl w-[95vw] h-[90vh] flex flex-col gap-3 p-4" data-testid="attachment-preview">
        <DialogHeader className="pr-8">
          <DialogTitle className="truncate text-base" data-testid="attachment-preview-name">{file?.name}</DialogTitle>
          <DialogDescription className="sr-only">Aperçu de la pièce jointe</DialogDescription>
        </DialogHeader>
        <div className="min-h-0 flex-1 overflow-hidden rounded-md border bg-muted/40">
          {kind === "pdf" && <iframe title={file?.name} src={url} className="h-full w-full" data-testid="attachment-preview-pdf" />}
          {kind === "image" && <div className="flex h-full items-center justify-center overflow-auto p-2"><img src={url} alt={file?.name} className="max-h-full max-w-full object-contain" data-testid="attachment-preview-image" /></div>}
          {kind === "other" && (
            <div className="flex h-full flex-col items-center justify-center gap-2 text-sm text-muted-foreground" data-testid="attachment-preview-unsupported">
              <FileText size={40} />Aperçu non disponible pour ce type de fichier.
            </div>
          )}
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="outline" size="sm" asChild><a href={url} target="_blank" rel="noopener noreferrer" data-testid="attachment-preview-newtab"><ArrowSquareOut size={14} className="mr-1" />Nouvel onglet</a></Button>
          <Button size="sm" asChild><a href={url} download={file?.name} data-testid="attachment-preview-download"><DownloadSimple size={14} className="mr-1" />Télécharger</a></Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
